    document.addEventListener('DOMContentLoaded', function() {
      const toggleButton = document.querySelector('.read-more-toggle');
      const shortDescription = document.querySelector('.short-description');
      const fullDescription = document.querySelector('.full-description');

      if (toggleButton && shortDescription && fullDescription) {
        toggleButton.addEventListener('click', function() {
          if (fullDescription.style.display === 'none') {
            fullDescription.style.display = 'block';
            shortDescription.style.display = 'none';
            toggleButton.textContent = 'Read Less';
          } else {
            fullDescription.style.display = 'none';
            shortDescription.style.display = 'block';
            toggleButton.textContent = 'Read More';
          }
        });
      }
    });